import React from "react"
import { translate } from "../../utils/language"
import { fileUrl } from "../../utils/path"

export const BlogpostDownload = ({data, language}) => {
    return <div className="blogpost-download">
        <a className="link" href={translate(language, data.Link_deutsch || fileUrl(data.Download_deutsch.url), data.Link_englisch || fileUrl(data.Download_englisch.url))}>{translate(language, data.Titel_deutsch, data.Titel_englisch)}</a>
    </div>
    }